<template>
  <div class="container">
    <!-- HEADER -->
    <div class = "has-text-centered">
      <h1 class = "title"> {{$t('contact.contactform.title')}} </h1> 
    </div>
    <div class="columns">
      <!-- FORM -->
      <div class="column is-6">
        <form>
          <!-- NAME -->
          <span class="label">{{$t('contact.contactform.name')}}</span>
          <div class="field">
            <div class="control">
              <input class="input" v-model="name" type = "text">
            </div>
          </div>
          <!-- EMAIL -->
          <span class="label">{{$t('contact.contactform.email')}}</span>
          <div class="field">
            <div class="control">
              <input class="input" v-model="email_addr" type = "text">
            </div>
          </div>
          <!-- TITLU -->
          <span class="label">{{$t('contact.contactform.titlu')}}</span>
          <div class="field">
            <div class="control">
              <input class="input" v-model="title" type = "text">
            </div>
          </div>
          <!-- TELEPHONE -->
          <span class = "telephone">{{$t('contact.contactform.telephone')}}</span>
          <div class="field telephone">
            <div class="control">
              <input class="telephone input" v-model="telephone_number" type = "text">
            </div>
          </div>
        </form>
      </div>
      <!-- TEXTAREA -->
      <div class="column is-6">
        <div class="field">
          <div class="control">
            <textarea v-model="message" class="textarea has-fixed-size" type="text" 
            placeholder="Write your message here!"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class = "sending-area">
      <div class = "button-area"> 
        <button class="button is-outlined is-large" 
          v-on:click="send" :class="{'is-loading': sending}">{{$t('contact.contactform.send')}}</button>
      </div>
      <div class = "output-area">
        <p class = "error-message" v-if="invalid"> {{$t(error_message)}} </p>
        <p class = "success-message" v-if="sent"> {{$t('contact.contactform.success_message')}} </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      name: '',
      email_addr: '',
      title: '',
      telephone_number: '',
      message: '',
      invalid: false,
      sent: false,
      sending: false,
      error_message: ''
    };
  },
  methods: {
    send() {
      this.invalid = false;
      if (this.name === '' || this.email_addr === '' || this.title === '' || this.message === '') {
        this.error_message = 'contact.contactform.invalid_message';
        this.invalid = true;
      } else if (!this.validateEmail(this.email_addr)) {
        this.error_message = 'contact.contactform.invalid_email'
        this.invalid = true;
      } 
      else {
        this.sending = true;
        this.postMessage();
      }
    },
    postMessage() {
      if (this.telephone_number) {
        return;
      }

      let postBody = {
        title: this.title,
        name: this.name,
        email_addr: this.email_addr,
        message: this.message
      }

      this.$http.post('https://eo9-backend.firebaseapp.com/api/contact', postBody).then(
        res => {
          this.resetForm();
          this.sent = true;
        },
        err => {
          this.sending = false;
          this.error_message = 'contact.contactform.network_issue';
          this.invalid = true;
        }
      )
    },
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    resetForm() {
      this.name = '';
      this.email_addr = '';
      this.title = '';
      this.telephone_number = '';
      this.message = '';
      this.sending = false;
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  margin-top: 50px;
  margin-bottom: 50px;
}

.title {
color: $primary-color;
font-size: 30px !important;
margin-bottom: 50px;
}

.textarea {
  margin-top: 24px;
}

.column {
  justify-content: start;
}

.telephone {
  display: none;
}

.error-message {
  color: $error;
}

.success-message {
  color: $success;
}

.sending-area {
  display: flex;
  flex-direction: column;
}

.button-area, .output-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.label {
  color: $primary-color;
}
</style>